import React from "react";
import { Edit, Trash2 } from "lucide-react";

const CHANNEL_LABELS = {
  email: "Email",
  sms: "SMS",
  both: "Email & SMS",
};

const getPlainTextPreview = (html = "") =>
  html
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const MarketingCampaignCard = ({ campaign, onEdit, onDelete, onView }) => {
  const preview =
    getPlainTextPreview(campaign.email_body) ||
    getPlainTextPreview(campaign.sms_body);

  return (
    <div
      onClick={() => onView(campaign)}
      className="flex flex-col bg-card rounded-xl border border-border shadow-sm hover:shadow-md transition-all relative overflow-hidden min-h-[200px] cursor-pointer"
    >
      <div className="self-stretch p-5 flex flex-col justify-start items-start gap-4">
        <div className="self-stretch inline-flex justify-start items-center gap-3 min-w-0">
          <h2
            className="flex-1 min-w-0 text-foreground text-base font-semibold font-['Inter'] leading-6 truncate"
            title={campaign.name}
          >
            {campaign.name}
          </h2>
        </div>

        <span className="px-2 py-1 text-xs font-medium rounded-full bg-muted text-muted-foreground">
          {CHANNEL_LABELS[campaign.channel] || campaign.channel || "Email"}
        </span>

        {campaign.channel !== "sms" && campaign.subject && (
          <p
            className="self-stretch text-foreground text-sm font-medium truncate"
            title={campaign.subject}
          >
            {campaign.subject}
          </p>
        )}

        <p
          className="self-stretch text-muted-foreground text-sm font-normal font-['Inter'] leading-5 line-clamp-3"
          title={preview}
        >
          {preview || "No content"}
        </p>
      </div>

      <div className="mt-auto self-stretch flex flex-col justify-start items-center">
        <div className="self-stretch h-px bg-border" />
        <div className="self-stretch px-5 py-4 inline-flex justify-between items-center gap-4">
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onEdit(campaign);
            }}
            className="text-muted-foreground hover:text-foreground transition-colors flex items-center gap-2 text-sm font-semibold"
            title="Edit Template"
          >
            <Edit className="w-4 h-4" />
            Edit
          </button>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(campaign);
            }}
            className="text-muted-foreground hover:text-red-600 transition-colors"
            title="Delete Template"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default MarketingCampaignCard;
